import React from 'react';
import { ChallengeIntroNotify } from './ChallengeIntroNotify';
import { NotAllowWriteNotify } from './NotAllowWriteNotify';
import { FragmentsDescriptionNotify } from './FragmentsDescriptionNotify';
import { WelcomeBonusNotify } from './WelcomeBonusNotify/WelcomeBonusNotify';
import { NewFragmentNotify } from './NewFragmentNotify';
import { TestBBuyFirstDrawNotify } from './TestB_BuyFirstDrawNotify/TestB_BuyFirstDrawNotify';
import { ChallengeRewardNotify } from './ChallengeRewardNotify/ChallengeRewardNotify';

export enum CustomNotifyType {
    ChallengeIntro = 1,
    NotAllowWrite = 2,
    FragmentsDescription = 3,    
    Welcome = 4,
    NewFragment = 5,
    TestB_BuyFirstDraw = 6,
    ChallengeReward = 7,
}

export interface ICustomNotifyRouterProps {
    closeHandler: () => void;
    customType?: CustomNotifyType;
    data?: any
}

export const CustomNotifyRouter: React.FC<ICustomNotifyRouterProps> = (notify) => {
    switch (notify.customType) {
        case CustomNotifyType.ChallengeIntro: return <ChallengeIntroNotify {...notify} />;
        case CustomNotifyType.NotAllowWrite: return <NotAllowWriteNotify {...notify} />;
        case CustomNotifyType.FragmentsDescription: return <FragmentsDescriptionNotify {...notify} />;
        case CustomNotifyType.Welcome:
            return <WelcomeBonusNotify {...notify} bonuses={ notify.data } />
        case CustomNotifyType.NewFragment: return <NewFragmentNotify {...notify} />;
        case CustomNotifyType.TestB_BuyFirstDraw: return <TestBBuyFirstDrawNotify {...notify} />;
        case CustomNotifyType.ChallengeReward: return <ChallengeRewardNotify {...notify}/>;
        default: return <></>;
    }
};